import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

const MassageSection = () => (
    <ScrollableAnchor id="massage">
      <section className="content-section bg-dark text-white text-center animatedParent animateOnce"
               data-sequence='500'>
        <div className="container">
          <div className="content-section-heading text-center">
            <h3 className="text-secondary mb-0">Info</h3>
            <h2 className="mb-5">Massagen</h2>
          </div>
          <div className="animated fadeInDownShort" data-id="1" >
            <p className="textJustify">Individuell erarbeitete Techniken, die auf deine Körperstrukturen angepasst
              werden um gemeinsamen einen weg der Zufriedenheit zu finden.</p>
          </div>
        </div>
      </section>
    </ScrollableAnchor>
);

export default MassageSection;



// WEBPACK FOOTER //
// ./src/courseinfo/massage.js